var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAnswersList = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 117,
  height: 117,
  viewBox: "0 0 117 117",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#F2BB00",
  width: 117,
  height: 117,
  rx: 16
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#FFF",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M100.5 94v12M94 99.538h13"
})), /*#__PURE__*/React.createElement("path", {
  d: "M34.802 36.188h31.302a18.396 18.396 0 0 1 18.089 15.046l7.213 38.954-10 11H34.802c-10.16 0-18.396-8.237-18.396-18.397V54.584c0-10.16 8.236-18.397 18.396-18.396Z",
  fill: "#DCA100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.802 25.188H73.01c10.16 0 18.396 8.236 18.396 18.396v46.603H44.802c-10.16 0-18.396-8.236-18.396-18.396V43.583c0-10.16 8.236-18.396 18.396-18.395Z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.197 40.219h19.687a3.656 3.656 0 0 1 0 7.312H52.197a3.656 3.656 0 0 1 0-7.312Z",
  fill: "#DCA100"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DCA100",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m43.89 56-3.86 4.803L38 59.604M43.89 42l-3.86 4.803L38 45.604M43.89 71l-3.86 4.803L38 74.604"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.197 54.844h12.326a3.656 3.656 0 0 1 0 7.312H52.197a3.656 3.656 0 0 1 0-7.312ZM52.197 69.469h19.687a3.656 3.656 0 0 1 0 7.312H52.197a3.656 3.656 0 0 1 0-7.312Z",
  fill: "#DCA100"
}))));

export default SvgAnswersList;